module.exports = __webpack_public_path__ + "img/assistance_login_google.116f131e.jpg";